export enum OnlineMeetingProvider {
    Jitsi = 'Jitsi',
    Jaas = 'Jaas'
}
